import { render } from "./full-modal.vue?vue&type=template&id=c69701b8&ts=true"
import script from "./full-modal.vue?vue&type=script&lang=ts"
export * from "./full-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__